/**
 * pages/MyAssignments.js — МИНИЙ ДААЛГАВАР.
 *
 * Зам: /my-assignments
 *
 * ⚠ ЯАГААД ЭНЭ ХУУДАС ХЭРЭГТЭЙ ВЭ:
 *   Шалгагч зөрчил дээр хариуцагч ба хугацаа тавьдаг («Б.Булгантамир ·
 *   2027-08-11 хүртэл»). Гэтэл ТУХАЙН ХҮН тэр даалгавраа хаанаас ч
 *   харах боломжгүй байв — `responsible_tn`-ээр шүүдэг зам огт байгаагүй.
 *   Улмаас хувиарлалт бүртгэгддэг ч ажил хөдөлдөггүй байлаа.
 *
 * УРСГАЛ:
 *   Хүлээгдэж буй → (би биелэлтээ илгээв) Баталгаажуулах хүлээж буй
 *                 → (шалгагч хүлээн авав) Биелсэн
 *   Буцаагдвал шалтгаантайгаа «Хүлээгдэж буй» руу эргэж ирнэ.
 */
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  Col,
  Empty,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Tag,
  Tooltip,
  Upload,
  message,
} from "antd";

import { fetchMyAssignments, submitAssignmentFix } from "src/api/assignment";
/* Хувиарлах / гүйцэтгэл оруулах цонх — шалгалтын хуудсан дээрхтэй ИЖИЛ */
import AssignmentEditor from "src/components/inspection/AssignmentEditor";
// Биелэлтийн зураг — аюулын зурагтай нэг MinIO хавтас/endpoint
import { uploadHazardPhoto } from "src/api/hazard";
import PageHelp from "src/components/help/PageHelp";
import moment from "moment";
import PeriodFilter from "src/components/filters/PeriodFilter";
/* Шүүлт ба эрэмбэ — цэвэр логик, тустай тестлэгддэг
   (src/pages/tests/myAssignments.logic.test.js) */
import { matchesTab, compareUrgency } from "./myAssignments.logic";

const BRAND = "#0F6E56";

const STATUS = {
  open: { label: "Хүлээгдэж буй", color: "#CA8A04", bg: "#FEF6E7" },
  in_progress: { label: "Хийгдэж буй", color: "#0EA5E9", bg: "#E8F5FE" },
  submitted: {
    label: "Баталгаажуулах хүлээж буй",
    color: "#7C3AED",
    bg: "#F3EDFF",
  },
  closed: { label: "Биелсэн", color: "#16A34A", bg: "#E7F6EC" },
};

/** Даалгаврын ТӨРӨЛ — хоёр өөр эх сурвалж нэг жагсаалтад ирдэг. */
const KINDS = [
  {
    key: "inspection",
    label: "Шалгалтын зөрчил",
    color: "#1D4ED8",
    icon: "fa-clipboard-check",
  },
  {
    key: "hazard",
    label: "Аюулын мэдээлэл",
    color: "#EA580C",
    icon: "fa-exclamation-triangle",
  },
];
const kindOf = (it) => (it.kind === "hazard" ? "hazard" : "inspection");

/**
 * МИНИЙ ДҮР энэ мөрөн дээр — ГҮЙЦЭТГЭХ үү, ХЯНАХ уу.
 *
 * ⚠ НЭГ ТОДОРХОЙЛОЛТ. Карт ба хяналтын хэсэг хоёр өөр газар бодвол
 *   «6 хяналт» гэж бичээд картууд дээр 5 нь л тийм байх эрсдэлтэй.
 *
 *   watch — зөрчлийг ажилтнуудад ХУВИАРЛАСАН: одоо тэдний гүйцэтгэлийг
 *           хянаж, хүлээн авах нь миний ажил
 *   do    — хувиарлаагүй зөрчил эсвэл надад ирсэн ажил: ӨӨРӨӨ арилгана
 *   view  — аюулын мэдээлэл: зөвхөн үзэх (`readonly`)
 */
const ROLES = {
  do: { t: "Гүйцэтгэх", ic: "fa-screwdriver-wrench", c: "#0F6E56" },
  watch: { t: "Хяналт тавих", ic: "fa-binoculars", c: "#7C3AED" },
  view: { t: "Танилцах", ic: "fa-eye", c: "#64748B" },
};
const roleKeyOf = (it) =>
  it.readonly ? "view" : (it.assignments || []).length > 0 ? "watch" : "do";
const roleOf = (it) => ({ k: roleKeyOf(it), ...ROLES[roleKeyOf(it)] });

/** Төрөл тус бүрээр: нийт / хийх ёстой / хүлээгдэж буй / шийдсэн / хугацаа хэтэрсэн */
function breakdownByKind(items) {
  const out = {};
  KINDS.forEach((k) => {
    out[k.key] = { total: 0, open: 0, submitted: 0, closed: 0, overdue: 0 };
  });
  (items || []).forEach((it) => {
    const b = out[kindOf(it)];
    const st = it.fix_status || "open";
    b.total += 1;
    if (st === "closed") b.closed += 1;
    else if (st === "submitted") b.submitted += 1;
    else b.open += 1;
    if (it.is_overdue) b.overdue += 1;
  });
  return out;
}

function Kpi({ label, value, color, onClick, active }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: active ? color + "12" : "#fff",
        border: `1px solid ${active ? color + "55" : "#E6E9EF"}`,
        borderRadius: 10,
        padding: "10px 12px",
        cursor: onClick ? "pointer" : "default",
        height: "100%",
      }}
    >
      <div style={{ fontSize: 24, fontWeight: 800, color, lineHeight: 1.1 }}>
        {value}
      </div>
      <div style={{ fontSize: 12, fontWeight: 600, color: "#1F2430" }}>
        {label}
      </div>
    </div>
  );
}

export default function MyAssignments() {
  const navigate = useNavigate();
  /* ⚠ ХУВИАРЛАХ цонх нь шалгалтын хуудсан дээрхтэй ИЖИЛ компонент —
     чиглэл (цахилгаан · механик · технологи · засвар), ажилтан, хугацаа,
     даалгавар. Энд дахин бичвэл хоёр газар зөрж, эрхийн дүрэм ч хуваагдана.
     `canAssign` — удирдлага (зөрчлийг хүлээн авсан хүн) хувиарлана;
     хувиарлагдсан ажилтан нь ӨӨРИЙН мөрөндөө гүйцэтгэл оруулна. */
  const [assignOf, setAssignOf] = useState(null);

  /** Буцах — түүх байвал өмнөх хуудас, эс бөгөөс (шууд хаягаар / мэдэгдлийн
   *  холбоосоор нээгдсэн) «Миний хуудас» руу. `history.state.idx` нь
   *  react-router-ийн стек дэх байрлал — 0 бол `navigate(-1)` аппаас гаргана
   *  (hazard/Detail.js-тэй ижил зарчим). */
  const goBack = () => {
    const idx = typeof window !== "undefined" ? window.history.state?.idx : undefined;
    if (typeof idx === "number" && idx > 0) navigate(-1);
    else navigate("/me");
  };
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("open");
  // Төрлөөр шүүх (null = бүгд) — «Хяналт» хэсгийн мөр дарахад
  const [kindFilter, setKindFilter] = useState(null);
  /* ── ХАЙЛТЫН ШҮҮЛТ (2026-10-04) ─────────────────────────────────────
     Хэрэглэгч: «ямар хугацаанд юу шийдсэн» гэдгээ хардаг болох.
     ⚠ ОГНООНЫ ХОЁР УТГА: `due_date` (хэзээ хийх ёстой) ба `fix_date`
       (хэзээ шийдсэн). «Юу шийдсэн» гэдгийг due_date-аар шүүвэл буруу
       хариу гарна — 1-р сард товлосон ажлыг 3-р сард шийдсэн байж болно.
       Тиймээс аль огноогоор шүүхийг ХЭРЭГЛЭГЧ сонгоно. */
  const [dateField, setDateField] = useState("due_date");
  const [period, setPeriod] = useState(null);   // [moment, moment] | null
  const [q, setQ] = useState("");
  /* Зөрчлийн МӨРӨӨР нь (`it.id`) шалгалтын хуудас руу шилжихэд «Буцах»
     нь энэ хуудас руугаа эргэж ирэхийн тулд `state.from` дамжуулна. */
  const openInspection = (insId) =>
    insId &&
    navigate(`/inspection/xab/${insId}`, {
      state: { from: "/my-assignments" },
    });
  const [fixOf, setFixOf] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  // Биелэлтийн ЗУРАГ (арилгасны дараах байдал) — URL. Нэг зураг: backend
  // `fix_photo_url` нэг багана. Илгээхийн өмнө upload хийгдэнэ.
  const [photoUrl, setPhotoUrl] = useState(null);
  const [uploading, setUploading] = useState(false);

  const onPickPhoto = async (file) => {
    if (!/^image\//.test(file.type || "")) {
      message.warning("Зөвхөн зураг хавсаргана");
      return false;
    }
    setUploading(true);
    try {
      const d = await uploadHazardPhoto(file);
      if (!d?.file_url) throw new Error("url");
      setPhotoUrl(d.file_url);
    } catch (e) {
      message.error(e?.response?.data?.message || "Зураг илгээж чадсангүй");
    } finally {
      setUploading(false);
    }
    return false; // antd-ийн өөрийн upload-ыг ХААНА — бид өөрсдөө илгээсэн
  };

  const load = useCallback(() => {
    setLoading(true);
    fetchMyAssignments()
      .then(setData)
      .catch((e) =>
        message.error(
          e?.response?.data?.message || "Даалгавар татаж чадсангүй",
        ),
      )
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const items = data?.items || [];
  const s = data?.summary || {};

  // ⚠ «Хүлээгдэж буй» табад `in_progress`-ыг ч оруулна — хэрэглэгчийн
  //   хувьд хоёулаа «хийх ёстой ажил», тусад нь хуваах нь ойлгомжгүй.
  /* ⚠ ХУГАЦААНЫ ШҮҮЛТ нь огноогүй мөрийг ХАСНА. «Хугацаа заагаагүй»
     даалгавар нь тухайн сард хамаарах эсэх нь мэдэгдэхгүй — оруулбал
     тоо үнэн биш болно. Хэрэглэгч хугацаа сонгоогүй бол бүгд харагдана. */
  const inPeriod = (it) => {
    if (!period || !period[0] || !period[1]) return true;
    const v = it[dateField];
    if (!v) return false;
    const m = moment(String(v).slice(0, 10), "YYYY-MM-DD");
    return m.isValid() && m.isBetween(period[0], period[1], "day", "[]");
  };
  /* Текст хайлт — зөрчил, үзүүлэлт, шалгалтын дугаар, шийдсэн тайлбар */
  const needle = q.trim().toLowerCase();
  const matchesText = (it) => {
    if (!needle) return true;
    return [
      it.finding_text, it.item_text, it.violated_rule, it.fix_note,
      it.violation_type_text, it.violator_name, it.penalty_text,
      it.inspection?.code, it.inspection?.bn_name, it.inspection?.tseh_name,
    ]
      .filter(Boolean)
      .some((x) => String(x).toLowerCase().includes(needle));
  };

  const scoped = items.filter((it) => inPeriod(it) && matchesText(it));
  const shown = scoped.filter(
    (it) =>
      (!kindFilter || kindOf(it) === kindFilter) && matchesTab(it, tab),
  );

  /* ── ХЯНАЛТЫН ХЭСЭГ: «би юуг шийдсэн, юуг шийдээгүй» ───────────────
     ⚠ ШҮҮСЭН ХҮРЭЭНД (`scoped`) тооцно, бүх өгөгдлөөр БИШ — эс бөгөөс
       «3-р сард юу шийдэв» гэж шүүсэн атал тоо нь бүх хугацааныхыг
       үзүүлж, хэрэглэгч андуурна.
     ⚠ Табын тоо (`s`) нь СЕРВЕРийнх, бүх хугацааных. Хоёр өөр тоо
       зэрэг харагдвал ойлгомжгүй тул энэ хэсгийг «шүүлтэд тохирсон»
       гэж ИЛ бичнэ. */
  const mon = (() => {
    const t = scoped.length;
    const done = scoped.filter((x) => x.fix_status === "closed").length;
    const wait = scoped.filter((x) => x.fix_status === "submitted").length;
    const over = scoped.filter((x) => x.is_overdue && x.fix_status !== "closed").length;
    const open = t - done - wait;
    const pcts = scoped.map((x) => Number(x.fix_percent || 0));
    const avg = t ? Math.round(pcts.reduce((a, b) => a + b, 0) / t) : 0;
    /* ── МИНИЙ АЖЛЫН БҮТЭЦ: хэд нь хяналт, хэд нь гүйцэтгэл ─────────
       ⚠ `roleOf` нь картынхтай ИЖИЛ туслах — хоёр газар бодвол тоо
         зөрнө. «Танилцах» (аюулын мэдээлэл) нь ГУРАВ ДАХЬ бүлэг:
         гүйцэтгэх ч, хянах ч ажил биш тул хольж болохгүй. */
    const nWatch = scoped.filter((x) => roleKeyOf(x) === "watch").length;
    const nDo = scoped.filter((x) => roleKeyOf(x) === "do").length;
    const nView = t - nWatch - nDo;
    /* Дүр тус бүрийн ШИЙДВЭРЛЭЛТ — «хяналтын ажлаа хэр биелүүлэв»
       гэдэг нь «өөрийн ажлаа хэр хийв»-ээс тусдаа асуулт. */
    const rateOf = (k) => {
      const rows = scoped.filter((x) => roleKeyOf(x) === k);
      if (!rows.length) return null;
      const d = rows.filter((x) => x.fix_status === "closed").length;
      return Math.round((d / rows.length) * 100);
    };
    return {
      t, done, wait, open, over, avg,
      rate: t ? Math.round((done / t) * 100) : 0,
      nWatch, nDo, nView,
      pctWatch: t ? Math.round((nWatch / t) * 100) : 0,
      pctDo: t ? Math.round((nDo / t) * 100) : 0,
      rateWatch: rateOf("watch"),
      rateDo: rateOf("do"),
    };
  })();
  const byKind = breakdownByKind(items);
  // Жагсаалтыг ТӨРЛӨӨР бүлэглэнэ — шалгалтын зөрчил, аюулын мэдээлэл
  // холилдож ирдэг байсан. Шалгалтынх дотроо шалгалтын дугаараар эрэмбэлнэ.
  const groups = KINDS.map((k) => ({
    ...k,
    rows: shown
      .filter((it) => kindOf(it) === k.key)
      .sort(compareUrgency),
  })).filter((g) => g.rows.length);

  const send = async () => {
    if (!note.trim()) return message.warning("Юу хийснээ бичнэ үү");
    setBusy(true);
    try {
      /* ⚠ ХАМГААЛАЛТ: `/xab/inspection-items/<int:_id>/fix` нь ЗӨВХӨН
         тоон id хүлээнэ. «asg-10» гэх нийлмэл id явуулбал 404 → браузер
         «CORS policy» гэж төөрөгдүүлэм алдаа хэлж, жинхэнэ шалтгаан
         нуугдана. Энд барьж, ОЙЛГОМЖТОЙ мессеж өгнө. */
      const rawId = fixOf.item_result_id ?? fixOf.id;
      if (!/^\d+$/.test(String(rawId))) {
        message.error(
          "Энэ мөрийн биелэлтийг «Гүйцэтгэл оруулах» товчоор илгээнэ",
        );
        setBusy(false);
        return;
      }
      const d = await submitAssignmentFix(rawId, {
        note: note.trim(),
        photo_url: photoUrl || undefined,
      });
      message.success(d?.message || "Илгээлээ");
      setFixOf(null);
      setNote("");
      setPhotoUrl(null);
      load();
    } catch (e) {
      message.error(e?.response?.data?.message || "Илгээж чадсангүй");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ padding: 16, background: "#F1F3F6", minHeight: "100%" }}>
      <style>{`
        /* ── ТАБ: дүрс + тоо + өнгө (2026-10-04) ──────────────────────
           Урьд нь antd Segmented байсан тул аль нь идэвхтэй, хэдэн ажил
           байгаа нь нэг харцаар мэдэгдэхгүй байв. */
        .ma-tabs { display:flex; gap:8px; flex-wrap:wrap; margin-bottom:12px; }
        .ma-tab {
          display:inline-flex; align-items:center; gap:7px;
          padding:7px 13px; border-radius:10px; cursor:pointer;
          background:#fff; border:1px solid #E2E8F0; color:#5B6472;
          font-size:12.5px; font-weight:600; transition:all .15s;
        }
        .ma-tab i { font-size:12px; color:var(--c); }
        .ma-tab-n {
          min-width:20px; padding:0 6px; border-radius:9px;
          background:#EEF2F7; color:#5B6472; font-size:11px; font-weight:800;
        }
        .ma-tab:hover { border-color:var(--c); color:var(--c); }
        .ma-tab.on {
          background:var(--c); border-color:var(--c); color:#fff;
          box-shadow:0 2px 8px rgba(15,23,42,.14);
        }
        .ma-tab.on i { color:#fff; }
        .ma-tab.on .ma-tab-n { background:rgba(255,255,255,.26); color:#fff; }

        /* ── ХЯНАЛТЫН ХЭСЭГ ─────────────────────────────────────────── */
        .ma-mon {
          background:#fff; border:1px solid #E6E9EF; border-radius:10px;
          padding:10px 12px; margin-bottom:10px;
        }
        .ma-mon-h { font-size:12.5px; font-weight:700; color:#163A5A; margin-bottom:7px; }
        .ma-mon-sub { font-weight:500; color:#8A94A6; margin-left:8px; font-size:11px; }
        .ma-mon-bar {
          display:flex; height:9px; border-radius:5px; overflow:hidden;
          background:#EEF2F7; margin-bottom:7px;
        }
        .ma-mon-bar .seg { display:block; height:100%; }
        .ma-mon-bar .seg.done { background:#16A34A; }
        .ma-mon-bar .seg.wait { background:#7C3AED; }
        .ma-mon-bar .seg.open { background:#CA8A04; }
        .ma-mon-l {
          display:flex; gap:16px; flex-wrap:wrap; align-items:center;
          font-size:11.5px; color:#3A4356;
        }
        .ma-mon-l .dot {
          display:inline-block; width:8px; height:8px; border-radius:4px;
          margin-right:5px; vertical-align:middle;
        }
        .ma-mon-l .dot.done { background:#16A34A; }
        .ma-mon-l .dot.wait { background:#7C3AED; }
        .ma-mon-l .dot.open { background:#CA8A04; }
        .ma-mon-l .dot.over { background:#DC2626; }

        /* ── КАРТ: ХОЁР БАГАНА (2026-10-04) ───────────────────────────
           Зүүн = бүх мэдээлэл · Баруун = тухайн зөрчилтэй холбоотой үйлдэл.
           ⚠ 900px-ээс доош НЭГ багана — утсан дээр хоёр багана шахагдаж,
             товч 80px өргөнтэй болж дарагдахгүй болдог. */
        .ma-card { display:grid; grid-template-columns:1fr; gap:12px; }
        @media (min-width: 900px) {
          .ma-card { grid-template-columns: minmax(0,1fr) 230px; }
          .ma-right { border-left:1px solid #EEF1F5; padding-left:12px; }
        }
        .ma-left { min-width:0; }       /* 0 бол урт текст баганыг тэлэхгүй */
        .ma-right { display:flex; flex-direction:column; gap:7px; }
        .ma-right-st {
          display:inline-flex; align-items:center; gap:6px;
          font-size:12px; font-weight:700; color:var(--c);
        }
        .ma-right-st .dot {
          width:8px; height:8px; border-radius:4px; background:var(--c);
        }
        .ma-right-due { font-size:11.5px; font-weight:600; }
        .ma-right-due i { margin-right:5px; }
        .ma-right-pct { display:flex; align-items:center; gap:7px; font-size:11.5px; }
        .ma-right-pct .bar {
          flex:1 1 auto; height:7px; border-radius:4px; background:#EEF2F7;
          overflow:hidden; min-width:0;
        }
        .ma-right-pct .bar > span { display:block; height:100%; }
        /* Товчнууд БҮТЭН ӨРГӨНӨӨР — баганад жигд харагдана */
        .ma-act { display:flex; flex-direction:column; gap:6px; margin-top:2px; }
        .ma-act > button, .ma-act > .ant-btn { width:100%; }

        /* ── МИНИЙ ДҮР (гүйцэтгэх / хяналт тавих) ───────────────────── */
        .ma-role {
          display:inline-flex; align-items:center; gap:5px;
          padding:2px 9px; border-radius:999px; font-size:10.5px;
          font-weight:800; letter-spacing:.2px;
          background:var(--c); color:#fff;
        }
        .ma-role i { font-size:10px; }

        /* ── ЗААЛТ, ШАЛГАЛТЫН МӨР ───────────────────────────────────── */
        .ma-meta { font-size:11.5px; color:#5A6478; line-height:1.5; }
        .ma-meta b { color:#3A4356; }
        .ma-clause {
          margin-top:6px; padding:6px 9px; border-radius:6px;
          background:#F6F8FB; border-left:3px solid #C7D2E0;
          font-size:11px; color:#45506A; line-height:1.45;
        }

        /* ── АЖЛЫН БҮТЭЦ: хяналт vs гүйцэтгэл ───────────────────────── */
        .ma-split {
          display:flex; gap:8px; flex-wrap:wrap; margin:8px 0 9px;
        }
        .ma-split-i {
          flex:1 1 180px; min-width:0;
          display:grid; grid-template-columns:auto 1fr auto; gap:3px 7px;
          align-items:center;
          padding:7px 10px; border-radius:8px;
          background:#FAFBFD; border:1px solid #EEF1F5;
          border-left:3px solid var(--c);
        }
        .ma-split-i i { color:var(--c); font-size:13px; grid-row:span 2; }
        .ma-split-i .l { font-size:11.5px; color:#5B6472; font-weight:600; }
        .ma-split-i .p { font-size:17px; font-weight:800; color:var(--c); grid-row:span 2; }
        .ma-split-i .n { font-size:10.5px; color:#8A94A6; grid-column:2; }

        /* ── ЗӨРЧЛИЙН ШИЙДВЭР (/inspection/types-тэй ижил хэв маяг) ──── */
        .ma-dec { display:flex; gap:6px; flex-wrap:wrap; margin-top:7px; }
        .ma-dec .chip {
          display:inline-flex; align-items:center; gap:5px;
          padding:2px 8px; border-radius:12px; font-size:11px; line-height:1.5;
        }
        .ma-dec .chip.viol  { background:#FEE2E2; color:#7F1D1D; }
        .ma-dec .chip.pen   { background:#FEF3C7; color:#92400E; }
        .ma-dec .chip.meas  { background:#DCFCE7; color:#14532D; }
        .ma-dec .chip.type  { background:#E0E7FF; color:#3730A3; }
        .ma-dec .chip.ser   { background:#7F1D1D; color:#fff; font-weight:700; }

        @media (max-width: 760px) {
          .ma-tab { padding:6px 10px; font-size:11.5px; }
          .ma-tab-t { display:none; }     /* нарийн дэлгэцэд дүрс + тоо л */
        }
      `}</style>

      {/* Толгой */}
      <div
        style={{
          background: `linear-gradient(135deg, ${BRAND} 0%, #0B5442 100%)`,
          borderRadius: 14,
          padding: "16px 18px",
          marginBottom: 14,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <Button
          onClick={goBack}
          title="Буцах"
          aria-label="Буцах"
          icon={<i className="fas fa-arrow-left" />}
          style={{
            background: "transparent",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.55)",
          }}
        />
        <i className="fas fa-clipboard-check" style={{ fontSize: 24 }} />
        <div style={{ flex: 1, minWidth: 200 }}>
          <h1
            style={{
              margin: 0,
              fontSize: 18,
              fontWeight: 500,
              color: "rgba(255,255,255,0.9)",
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            Миний даалгавар
            <PageHelp light style={{ marginLeft: 4 }} />
          </h1>
          <p style={{ margin: "2px 0 0", fontSize: 12, opacity: 0.85 }}>
            Надад хуваарилагдсан аюулын мэдээлэл ба шалгалтын зөрчил
          </p>
        </div>
        <Button
          onClick={load}
          style={{
            background: "transparent",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.55)",
          }}
        >
          <i className="fas fa-sync-alt" style={{ marginRight: 6 }} />
          Шинэчлэх
        </Button>
      </div>

      {data?.fix_ready === false ? (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 12 }}
          message="Биелэлт илгээх боломж хараахан идэвхжээгүй"
          description="Мэдээллийн санд шинэ багана нэмэгдэх шаардлагатай (alter_item_fix_submission.sql). Даалгавраа харах боломжтой ч илгээх товч ажиллахгүй."
        />
      ) : null}

      {/* Хяналт */}
      <Row gutter={[10, 10]} style={{ marginBottom: 12 }}>
        <Col xs={12} md={6}>
          <Kpi
            label="Хийх ёстой"
            value={s.open || 0}
            color="#CA8A04"
            active={tab === "open"}
            onClick={() => setTab("open")}
          />
        </Col>
        <Col xs={12} md={6}>
          <Kpi
            label="Баталгаажуулах хүлээж буй"
            value={s.submitted || 0}
            color="#7C3AED"
            active={tab === "submitted"}
            onClick={() => setTab("submitted")}
          />
        </Col>
        <Col xs={12} md={6}>
          <Kpi
            label="Биелсэн"
            value={s.closed || 0}
            color="#16A34A"
            active={tab === "closed"}
            onClick={() => setTab("closed")}
          />
        </Col>
        <Col xs={12} md={6}>
          {/* ⚠ Хугацаа хэтэрсэн нь ТУСДАА тоо — хийх ёстойн дотор багтдаг
              ч тусад нь харуулахгүй бол анзаарагдахгүй өнгөрнө.
              ⚠ ДАРЖ ШҮҮНЭ (2026-10-01): бусад гурван карт шүүдэг атал энэ
                нь ганцаараа дардаггүй байв — хамгийн яаралтай тоог харсан
                хүн алийг нь гэдгээ олох аргагүй байлаа. */}
          <Kpi
            label="Хугацаа хэтэрсэн"
            value={s.overdue || 0}
            color="#DC2626"
            active={tab === "overdue"}
            onClick={() => setTab("overdue")}
          />
        </Col>
      </Row>

      {/* Төрлөөр: аюулын бүртгэлээс хэд шийдсэн, шалгалтын зөрчлөөс хэд шийдсэн.
          Мөр дарахад тэр төрлөөр шүүнэ (дахин дарвал болино). */}
      <Card
        size="small"
        style={{ marginBottom: 12, borderRadius: 10 }}
        bodyStyle={{ padding: "6px 12px" }}
      >
        {KINDS.map((k) => {
          const b = byKind[k.key];
          const active = kindFilter === k.key;
          const pct = b.total ? Math.round((b.closed / b.total) * 100) : 0;
          return (
            <div
              key={k.key}
              onClick={() => setKindFilter(active ? null : k.key)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                flexWrap: "wrap",
                padding: "6px 4px",
                cursor: "pointer",
                borderRadius: 6,
                background: active ? k.color + "10" : "transparent",
              }}
            >
              <i
                className={`fas ${k.icon}`}
                style={{ color: k.color, width: 18, textAlign: "center" }}
              />
              <b style={{ color: k.color, minWidth: 140 }}>{k.label}</b>
              <span style={{ fontSize: 12.5, color: "#3A4356" }}>
                нийт <b>{b.total}</b> · шийдсэн{" "}
                <b style={{ color: "#16A34A" }}>{b.closed}</b> · хүлээгдэж буй{" "}
                <b style={{ color: "#7C3AED" }}>{b.submitted}</b> · хийх ёстой{" "}
                <b style={{ color: "#CA8A04" }}>{b.open}</b>
                {b.overdue ? (
                  <>
                    {" "}
                    · хэтэрсэн <b style={{ color: "#DC2626" }}>{b.overdue}</b>
                  </>
                ) : null}
              </span>
              <div
                style={{
                  flex: "1 1 120px",
                  minWidth: 100,
                  maxWidth: 240,
                  height: 6,
                  background: "#EEF1F5",
                  borderRadius: 3,
                }}
              >
                <div
                  style={{
                    width: `${pct}%`,
                    height: "100%",
                    background: "#16A34A",
                    borderRadius: 3,
                  }}
                />
              </div>
              <span style={{ fontSize: 11.5, color: "#5A6478", minWidth: 36 }}>
                {pct}%
              </span>
              {active ? (
                <Tag color={k.color} style={{ marginInlineEnd: 0 }}>
                  шүүсэн ✕
                </Tag>
              ) : null}
            </div>
          );
        })}
      </Card>

      {/* ══════════ ХАЙЛТ, ШҮҮЛТ ══════════
          ⚠ НЭГ МӨРӨНД: хугацаа · огнооны төрөл · текст. Хэрэглэгч
            «3-р сард юу шийдсэн бэ» гэдгээ хоёр товшилтоор хардаг. */}
      <Card
        bodyStyle={{ padding: 8 }}
        style={{ marginBottom: 10 }}
        className="ma-filter"
      >
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          <span style={{ fontSize: 12, color: "#8A94A6", fontWeight: 600 }}>
            <i className="fas fa-filter" style={{ marginRight: 5 }} />
            Хугацаа:
          </span>
          <PeriodFilter value={period} onChange={setPeriod} size="small" />
          {/* ⚠ АЛЬ ОГНООГООР гэдгийг ИЛ сонгуулна. «Товлосон» ба
              «шийдсэн» хоёр өөр асуулт: эхнийх «юу хийх ёстой байв»,
              хоёр дахь нь «юуг хэзээ шийдэв». */}
          <Select
            size="small"
            style={{ width: 150 }}
            value={dateField}
            onChange={setDateField}
            options={[
              { value: "due_date", label: "Товлосон хугацаа" },
              { value: "fix_date", label: "Шийдсэн огноо" },
            ]}
          />
          <Input
            size="small"
            allowClear
            style={{ width: 230 }}
            placeholder="Зөрчил, шалгалт, хүн, шийтгэл…"
            prefix={<i className="fas fa-search" style={{ color: "#B9C0CC" }} />}
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          {period || q ? (
            <Button
              size="small"
              type="text"
              onClick={() => {
                setPeriod(null);
                setQ("");
              }}
            >
              <i className="fas fa-times" style={{ marginRight: 4 }} />
              Цэвэрлэх
            </Button>
          ) : null}
          <span style={{ marginLeft: "auto", fontSize: 11.5, color: "#8A94A6" }}>
            шүүлтэд тохирсон: <b style={{ color: "#1F2430" }}>{scoped.length}</b>
          </span>
        </div>
      </Card>

      {/* ══════════ ХЯНАЛТ — «би юуг шийдсэн, юуг шийдээгүй» ══════════
          ⚠ ЭНЭ нь ШҮҮСЭН ХҮРЭЭНИЙ тоо (дээрх картууд нь БҮХ хугацааных).
            Ялгааг нь бичихгүй бол хоёр өөр тоо зэрэг харагдаж андуурна. */}
      {scoped.length ? (
        <div className="ma-mon">
          <div className="ma-mon-h">
            <i className="fas fa-chart-pie" style={{ marginRight: 6 }} />
            Миний шийдвэрлэлт
            <span className="ma-mon-sub">
              {period
                ? `${period[0].format("YYYY-MM-DD")} — ${period[1].format("YYYY-MM-DD")}`
                : "бүх хугацаа"}
              {q ? ` · «${q}»` : ""}
            </span>
          </div>
          <div className="ma-mon-bar">
            <span className="seg done" style={{ width: `${(mon.done / mon.t) * 100}%` }} />
            <span className="seg wait" style={{ width: `${(mon.wait / mon.t) * 100}%` }} />
            <span className="seg open" style={{ width: `${(mon.open / mon.t) * 100}%` }} />
          </div>
          {/* ── МИНИЙ АЖЛЫН БҮТЭЦ: хяналт vs гүйцэтгэл ────────────────
              ⚠ Хэрэглэгчийн асуулт: «миний хяналт хийх хэд %, гүйцэтгэх
                хэд %». Хоёр нь ӨӨР ажил — хяналт нь бусдын гүйцэтгэлийг
                хүлээн авах, гүйцэтгэл нь өөрөө арилгах. Нийлүүлж нэг
                тоо харуулбал «би юугаар илүү завгүй байна» гэдэг нь
                мэдэгдэхгүй.
              ⚠ Шийдвэрлэлтийг нь ТУС ТУСАД нь бодно: хянах ажлаа
                биелүүлсэн эсэх ба өөрийн ажлаа хийсэн эсэх хоёр өөр. */}
          {mon.nWatch || mon.nDo ? (
            <div className="ma-split">
              {mon.nDo ? (
                <div className="ma-split-i" style={{ "--c": "#0F6E56" }}>
                  <i className="fas fa-screwdriver-wrench" />
                  <span className="l">Гүйцэтгэх ажил</span>
                  <b className="p">{mon.pctDo}%</b>
                  <span className="n">
                    {mon.nDo} ширхэг
                    {mon.rateDo != null ? ` · ${mon.rateDo}% шийдсэн` : ""}
                  </span>
                </div>
              ) : null}
              {mon.nWatch ? (
                <div className="ma-split-i" style={{ "--c": "#7C3AED" }}>
                  <i className="fas fa-binoculars" />
                  <span className="l">Хяналт тавих ажил</span>
                  <b className="p">{mon.pctWatch}%</b>
                  <span className="n">
                    {mon.nWatch} ширхэг
                    {mon.rateWatch != null ? ` · ${mon.rateWatch}% хаагдсан` : ""}
                  </span>
                </div>
              ) : null}
              {mon.nView ? (
                <div className="ma-split-i" style={{ "--c": "#64748B" }}>
                  <i className="fas fa-eye" />
                  <span className="l">Зөвхөн танилцах</span>
                  <b className="p">{Math.round((mon.nView / mon.t) * 100)}%</b>
                  <span className="n">{mon.nView} ширхэг</span>
                </div>
              ) : null}
            </div>
          ) : null}

          <div className="ma-mon-l">
            <span><i className="dot done" />Шийдсэн <b>{mon.done}</b></span>
            <span><i className="dot wait" />Хүлээгдэж буй <b>{mon.wait}</b></span>
            <span><i className="dot open" />Шийдээгүй <b>{mon.open}</b></span>
            {mon.over ? (
              <span style={{ color: "#DC2626" }}>
                <i className="dot over" />Хугацаа хэтэрсэн <b>{mon.over}</b>
              </span>
            ) : null}
            <span style={{ marginLeft: "auto" }}>
              Шийдвэрлэлт <b style={{ color: "#16A34A" }}>{mon.rate}%</b>
              <span style={{ color: "#8A94A6" }}> · дундаж гүйцэтгэл </span>
              <b>{mon.avg}%</b>
            </span>
          </div>
        </div>
      ) : null}

      {/* ══════════ ТАБ ══════════
          ⚠ Урьд нь энгийн `Segmented` байсан тул шүүлтийн төлөв
            анзаарагдахгүй, тоо нь ч харагддаггүй байв. Одоо дүрс +
            тоо + өнгөөр ялгана. Тоо нь СЕРВЕРийн нийт дүн. */}
      <div className="ma-tabs">
        {[
          { v: "open", t: "Хийх ёстой", n: s.open || 0, ic: "fa-clipboard-list", c: "#CA8A04" },
          ...(s.overdue
            ? [{ v: "overdue", t: "Хугацаа хэтэрсэн", n: s.overdue, ic: "fa-triangle-exclamation", c: "#DC2626" }]
            : []),
          { v: "submitted", t: "Хүлээгдэж буй", n: s.submitted || 0, ic: "fa-paper-plane", c: "#7C3AED" },
          { v: "closed", t: "Биелсэн", n: s.closed || 0, ic: "fa-circle-check", c: "#16A34A" },
          { v: "all", t: "Бүгд", n: s.total || items.length, ic: "fa-layer-group", c: "#1F4E79" },
        ].map((o) => (
          <button
            key={o.v}
            type="button"
            className={"ma-tab" + (tab === o.v ? " on" : "")}
            style={{ "--c": o.c }}
            onClick={() => setTab(o.v)}
          >
            <i className={"fas " + o.ic} />
            <span className="ma-tab-t">{o.t}</span>
            <span className="ma-tab-n">{o.n}</span>
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spin />
        </div>
      ) : !shown.length ? (
        <Card>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              tab === "open"
                ? "Танд хийх даалгавар алга — сайн байна."
                : tab === "overdue"
                  ? "Хугацаа хэтэрсэн даалгавар алга — сайн байна."
                  : "Энэ төлөвт даалгавар алга."
            }
          />
        </Card>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {groups.map((g) => (
            <React.Fragment key={g.key}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginTop: 4,
                  paddingBottom: 4,
                  borderBottom: `2px solid ${g.color}`,
                  color: g.color,
                  fontWeight: 800,
                  fontSize: 13,
                }}
              >
                <i className={`fas ${g.icon}`} />
                {g.label}
                <span
                  style={{ fontWeight: 600, color: "#5A6478", fontSize: 12 }}
                >
                  ({g.rows.length})
                </span>
              </div>
              {g.rows.map((it) => {
                const st = STATUS[it.fix_status || "open"] || STATUS.open;
                const ins = it.inspection || {};
                /* ── МИНИЙ ДҮР: ГҮЙЦЭТГЭХ үү, ХЯНАХ уу ──────────────────
                   ⚠ Хоёр огт өөр ажил нэг жагсаалтад холилдож байв:
                     • надад хувиарлагдсан ажил (`asg-*`) ба өөрөө засах
                       зөрчил → ГҮЙЦЭТГЭНЭ
                     • бусдад хувиарласан зөрчил → тэдний ажлыг ХЯНАНА
                   Ялгаж харуулахгүй бол «би юу хийх ёстой» нь
                   ойлгомжгүй болж, хянах ажлыг гүйцэтгэх гэж андуурна. */
                const role = roleOf(it);
                return (
                  <Card
                    key={it.id}
                    size="small"
                    style={{
                      borderRadius: 10,
                      borderLeft: `3px solid ${it.is_overdue ? "#DC2626" : st.color}`,
                    }}
                    bodyStyle={{ padding: "10px 14px" }}
                  >
                    {/* ══ ХОЁР БАГАНА: зүүн = мэдээлэл · баруун = үйлдэл ══
                        ⚠ Урьд нь бүгд нэг багананд дараалан байсан тул
                          товч нь хамгийн доор, уншихын тулд гүйлгэх
                          шаардлагатай байв. Нарийн дэлгэцэд (900px-ээс
                          доош) нэг багана болж буцна. */}
                    <div className="ma-card">
                    <div className="ma-left">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        flexWrap: "wrap",
                      }}
                    >
                      {/* Миний дүр — хамгийн эхэнд, хамгийн тод */}
                      <span
                        className="ma-role"
                        style={{ "--c": role.c }}
                        title={
                          role.k === "watch"
                            ? "Та энэ зөрчлийг ажилтнуудад хувиарласан — тэдний гүйцэтгэлийг хянаж, хүлээн авна"
                            : role.k === "do"
                              ? "Та өөрөө арилгаж, биелэлтээ илгээнэ"
                              : "Зөвхөн үзэх"
                        }
                      >
                        <i className={"fas " + role.ic} />
                        {role.t}
                      </span>
                      <span
                        style={{
                          fontSize: 10.5,
                          fontWeight: 700,
                          padding: "1px 8px",
                          borderRadius: 999,
                          background: st.bg,
                          color: st.color,
                        }}
                      >
                        {st.label}
                      </span>
                      {it.is_overdue ? (
                        <Tag color="red" style={{ marginInlineEnd: 0 }}>
                          хугацаа хэтэрсэн
                        </Tag>
                      ) : null}
                      {/* Хоёр өөр эх сурвалж нэг жагсаалтад — ялгаж харуулна */}
                      <Tag
                        color={it.kind === "hazard" ? "orange" : "blue"}
                        style={{ marginInlineEnd: 0 }}
                      >
                        {it.kind === "hazard"
                          ? "Аюулын мэдээлэл"
                          : "Шалгалтын зөрчил"}
                      </Tag>
                      {it.due_date ? (
                        <span
                          style={{
                            fontSize: 11.5,
                            fontWeight: 700,
                            color: it.is_overdue ? "#DC2626" : "#5A6478",
                          }}
                        >
                          {String(it.due_date).slice(0, 10)} хүртэл
                        </span>
                      ) : (
                        <Tooltip title="Хугацаа заагаагүй даалгавар хэрэгждэггүй — шалгагчаас тодруулна уу">
                          <span style={{ fontSize: 11.5, color: "#C2860B" }}>
                            хугацаа заагаагүй
                          </span>
                        </Tooltip>
                      )}
                    </div>

                    {/* ── ЯГ ЯМАР ЗӨРЧИЛ ГАРГАСАН ──────────────────────
                        ⚠ `finding_text` = «юу илэрсэн», `item_text` =
                          «юуг шалгасан». Гарчигт нь ЗӨРЧЛИЙГ тавина;
                          шалгасан үзүүлэлт нь доорх блокт контекст болж
                          орно. Хоёрыг хольвол хариуцагч юуг засахаа
                          мэдэхгүй.
                        ⚠ Давхардуулахгүй: `finding_text` нь ЗӨВХӨН энд. */}
                    <div
                      style={{
                        fontSize: 13.5,
                        color: "#1F2430",
                        marginTop: 7,
                        fontWeight: 600,
                        lineHeight: 1.4,
                      }}
                    >
                      <span
                        style={{
                          fontSize: 10.5,
                          fontWeight: 800,
                          color: "#8A94A6",
                          marginRight: 6,
                        }}
                      >
                        №{it.item_no}
                      </span>
                      {it.finding_text || it.item_text}
                    </div>
                    {/* ⚠ ЗӨРЧИГДСӨН ЗААЛТЫГ ЭНД ДАВТАХГҮЙ. Доорх
                        `ma-clause` блокт бүрэн (үзүүлэлт + заалт + арга
                        хэмжээ) гардаг — хоёр газар бичвэл нэг зөрчил дээр
                        заалт ХОЁР УДАА харагдана (2026-10-04). */}

                    {/* ── ХААНА, АЛЬ ШАЛГАЛТААР, ХЭН ДААЛГАСАН ───────────
                        ⚠ ШАЛГАЛТЫН ДУГААР ба ШАТ нь урьд нь ОГТ харагддаггүй
                          байв. Хариуцагч «аль шалгалтын зөрчил вэ» гэдгээ
                          мэдэхгүй бол албан шаардлага, актанд холбож
                          чадахгүй бөгөөд эргэлзээ төрвөл хаанаас шалгахаа
                          ч мэдэхгүй. */}
                    <div className="ma-meta" style={{ marginTop: 5 }}>
                      {/* ⚠ ШАТ нь ТУСДАА, ТОД шошго: «IV шатны үзлэгээр
                          илэрсэн зөрчил» гэдэг нь хариуцлагын түвшинг
                          заана (IV шат = комиссын шалгалт). Дугаартай
                          нийлүүлбэл анзаарагдахгүй өнгөрнө. */}
                      {ins.stage_name ? (
                        <Tag
                          style={{
                            marginInlineEnd: 6,
                            fontSize: 10.5,
                            fontWeight: 700,
                            background: "#1D4ED8",
                            color: "#fff",
                            border: "none",
                          }}
                        >
                          <i className="fas fa-user-shield" style={{ marginRight: 4 }} />
                          {ins.stage_name}-ны үзлэг
                        </Tag>
                      ) : null}
                      {ins.code ? (
                        <Tag
                          color="blue"
                          style={{ marginInlineEnd: 6, fontSize: 10.5 }}
                        >
                          <i className="fas fa-clipboard-check" style={{ marginRight: 4 }} />
                          {ins.code}
                        </Tag>
                      ) : null}
                      {[
                        ins.bn_name,
                        ins.tseh_name,
                        ins.area_location,
                        ins.inspection_date,
                      ]
                        .filter(Boolean)
                        .join(" · ")}
                      {/* ⚠ «даалгасан» БИШ «ШАЛГАГЧ». `inspector_name` нь
                          шалгалтыг ХИЙСЭН хүн — даалгавар хувиарласан
                          хүнээс өөр. Буруу нэрлэвэл хариуцагч эргэлзээтэй
                          асуудлаа хэнээс тодруулахаа мэдэхгүй. */}
                      {ins.inspector_name ? (
                        <span style={{ marginLeft: 4 }}>
                          · <b>Шалгагч:</b> {ins.inspector_name}
                        </span>
                      ) : null}
                      {/* ⚠ ХЭН ДААЛГАСАН — ШАЛГАГЧААС ӨӨР хүн байж болно:
                          зөрчлийг хүлээн авсан удирдлага ажилтнууддаа
                          чиглэлээр нь тараадаг. Хариуцагч эргэлзээтэй
                          асуудлаа ХЭНЭЭС тодруулахаа мэдэх ёстой
                          (2026-10-08, хэрэглэгчийн хүсэлт). */}
                      {it.assigned_by_name ? (
                        <span style={{ marginLeft: 4 }}>
                          · <b>Даалгасан:</b> {it.assigned_by_name}
                          {it.assigned_date ? (
                            <span style={{ color: "#8A94A6" }}>
                              {" "}
                              ({String(it.assigned_date).slice(0, 10)})
                            </span>
                          ) : null}
                        </span>
                      ) : null}
                    </div>

                    {/* ── ЮУ ХИЙХ · ЭХ ЗӨРЧИЛ ───────────────────────────
                        ⚠ Хувиарлагдсан ажлын гарчигт ДААЛГАВРЫН бичвэр
                          буудаг тул «юунаас болж энэ ажил гарсан» нь
                          алдагддаг байв. Хоёрыг ТУСАД нь харуулна:
                            Юу хийх   — удирдлагын өгсөн даалгавар
                            Эх зөрчил — шалгалтаар илэрсэн зөрчил
                          Хоёр бичвэр ижил бол давхардуулахгүй. */}
                    {it.task_text && it.source_finding_text &&
                    String(it.task_text).trim() !==
                      String(it.source_finding_text).trim() ? (
                      <div className="ma-clause">
                        <div>
                          <b>Юу хийх:</b> {it.task_text}
                        </div>
                        <div style={{ marginTop: 3 }}>
                          <b>Эх зөрчил:</b> {it.source_finding_text}
                        </div>
                      </div>
                    ) : null}

                    {/* ── ШАЛГАСАН ҮЗҮҮЛЭЛТ ба ЗӨРЧИГДСӨН ЗААЛТ ──────────
                        ⚠ «Юуг шалгаж байгаад илрүүлсэн», «ямар заалт
                          зөрчсөн» хоёр нь зөрчлийг арилгах үндэслэл.
                          Эдгээргүйгээр хариуцагч юуг ямар стандартад
                          нийцүүлэхээ мэдэхгүй.
                        ⚠ `violation_clause_texts` (олон заалт) нь
                          `violated_rule`-аас ДЭЭГҮҮР: шалгагч заалтаа
                          лавлахаас сонгосон бол тэр нь албан ёсны. */}
                    {it.item_text ||
                    it.violation_clause_texts ||
                    it.violated_rule ||
                    it.serious_violation ? (
                      <div className="ma-clause">
                        {/* ⚠ ГАРЧИГТ `finding_text` байхгүй бол тэнд
                            `item_text` буудаг — тэр үед ЭНД дахин
                            харуулбал нэг текст ХОЁР УДАА гарна. */}
                        {it.item_text && it.finding_text ? (
                          <div>
                            <b>Шалгасан үзүүлэлт:</b> {it.item_text}
                          </div>
                        ) : null}
                        {/* ── ЗӨРЧИГДСӨН ЗААЛТ ────────────────────────
                            ⚠ `violation_clause_texts` нь ОЛОН заалтыг
                              МӨР ТАСЛАЛААР агуулдаг (ids-тэй тоо нь
                              таарна: 2=2, 3=3). HTML-д мөр таслал
                              үл харагддаг тул 500-800 тэмдэгтийн нэг
                              блок болж, аль нь хаанаа дуусахыг уншигч
                              ялгаж чадахгүй байв. Заалт тус бүрийг
                              ТУСДАА мөрөөр гаргана. */}
                        {it.violation_clause_texts || it.violated_rule ? (
                          <div style={{ marginTop: it.item_text ? 3 : 0 }}>
                            <b>Зөрчигдсөн заалт:</b>
                            {String(it.violation_clause_texts || it.violated_rule)
                              .split(/\r?\n/)
                              .map((x) => x.trim())
                              .filter(Boolean)
                              .map((x, n) => (
                                <div
                                  key={n}
                                  style={{ paddingLeft: 10, marginTop: 2 }}
                                >
                                  · {x}
                                </div>
                              ))}
                          </div>
                        ) : null}

                        {/* ── ЯГ ЯМАР ЗӨРЧИЛ ВЭ (ноцтой зөрчлийн лавлах) ──
                            ⚠ 7 мөрд «Зөрчигдсөн заалт» нь ЗӨВХӨН КОД
                              (`ХЭМАБМТ-06-Х1.1`) гэж гардаг — хариуцагчид
                              ямар ч утга хэлэхгүй. Утга нь
                              `serious_violation.text`-д байсан ч зөвхөн
                              tooltip дотор нуугдаж байв. Ил гаргана. */}
                        {it.serious_violation?.text ? (
                          <div
                            style={{
                              marginTop: 4,
                              paddingLeft: 10,
                              color: "#7F1D1D",
                              fontWeight: 600,
                            }}
                          >
                            <i
                              className="fas fa-radiation"
                              style={{ marginRight: 5 }}
                            />
                            Ноцтой зөрчил №{it.serious_violation.no}:{" "}
                            {it.serious_violation.text}
                          </div>
                        ) : null}
                        {it.remedy_plan ? (
                          <div style={{ marginTop: 3 }}>
                            <b>Арилгах арга хэмжээ:</b> {it.remedy_plan}
                          </div>
                        ) : null}
                      </div>
                    ) : null}

                    {/* ══ ЗӨРЧЛИЙН ШИЙДВЭР ══
                        ⚠ `/inspection/types`-д харагддаг мэдээллийг ЭНД ч
                          гаргана: хариуцагч өөрт ногдсон зөрчил ЯМАР
                          шийдвэртэйг (хэн гаргасан, ямар шийтгэл, ямар
                          арга хэмжээ) мэдэхгүй бол юу засахаа ойлгохгүй.
                        ⚠ Backend аль хэдийн БҮХ талбарыг өгдөг
                          (my_assignment.py `_item_payload`) — шинэ
                          хүсэлт нэмэхгүй. */}
                    {it.serious_violation ||
                    it.violation_type_text ||
                    it.violator_name ||
                    it.penalty_text ||
                    it.measure_text ? (
                      <div className="ma-dec">
                        {it.serious_violation ? (
                          <Tooltip title={it.serious_violation.text}>
                            <span className="chip ser">
                              <i className="fas fa-radiation" />
                              Ноцтой №{it.serious_violation.no}
                            </span>
                          </Tooltip>
                        ) : null}
                        {it.violation_type_text ? (
                          <span className="chip type">
                            <i className="fas fa-tag" />
                            {it.violation_type_text}
                          </span>
                        ) : null}
                        {it.violator_name ? (
                          <Tooltip title={it.violator_position || ""}>
                            <span className="chip viol">
                              <i className="fas fa-user-slash" />
                              {it.violator_name}
                            </span>
                          </Tooltip>
                        ) : null}
                        {it.penalty_text ? (
                          <span className="chip pen">
                            <i className="fas fa-gavel" />
                            {it.penalty_text}
                          </span>
                        ) : null}
                        {it.measure_text ? (
                          <span className="chip meas">
                            <i className="fas fa-screwdriver-wrench" />
                            {it.measure_text}
                          </span>
                        ) : null}
                      </div>
                    ) : null}

                    {/* ⚠ ГҮЙЦЭТГЭЛИЙН ХУВЬ — `/inspection/types`-ийнхтэй
                        ИЖИЛ томьёогоор backend бодно (`IIA.percent_of`).
                        Энд дахин бодвол хоёр хуудас өөр тоо үзүүлнэ. */}
                    {it.fix_percent != null && it.fix_status !== "closed" ? (
                      <div
                        style={{
                          marginTop: 7,
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          fontSize: 11.5,
                        }}
                      >
                        <span style={{ color: "#8A94A6" }}>Гүйцэтгэл</span>
                        <span
                          style={{
                            flex: "0 0 110px",
                            height: 7,
                            borderRadius: 4,
                            background: "#EEF2F7",
                            overflow: "hidden",
                          }}
                        >
                          <span
                            style={{
                              display: "block",
                              width: `${Math.min(100, it.fix_percent)}%`,
                              height: "100%",
                              background:
                                it.fix_percent >= 100
                                  ? "#16A34A"
                                  : it.fix_percent > 0
                                    ? "#CA8A04"
                                    : "#D6DBE3",
                            }}
                          />
                        </span>
                        <b>{it.fix_percent}%</b>
                      </div>
                    ) : null}

                    {/* Буцаагдсан бол шалтгаан нь хамгийн чухал */}
                    {it.fix_reject_note ? (
                      <div
                        style={{
                          marginTop: 7,
                          padding: "7px 10px",
                          background: "#FDECEC",
                          borderRadius: 6,
                          fontSize: 12,
                          color: "#8C2A22",
                        }}
                      >
                        <b>Буцаасан:</b> {it.fix_reject_note}
                      </div>
                    ) : null}

                    {/* ⚠ УДИРДЛАГЫН ХАРАГДАЦ: өөрөө тараасан ажлын явц.
                        Хэн, ямар чиглэлээр, хэдэн хувь — нэг харцаар.
                        Эс бөгөөс шалгалтын хуудас нээж байж мэднэ. */}
                    {it.assignments?.length ? (
                      <div style={{ marginTop: 7 }}>
                        {it.assignments.map((a) => (
                          <div
                            key={a.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              flexWrap: "wrap",
                              fontSize: 11.5,
                              color: "#3A4356",
                              padding: "3px 0",
                              borderTop: "1px dashed #EEF1F5",
                            }}
                          >
                            <Tag
                              style={{ marginInlineEnd: 0, fontSize: 10.5 }}
                              color={a.status === "closed" ? "green" : "blue"}
                            >
                              {a.category_label || "чиглэл заагаагүй"}
                            </Tag>
                            <b>{a.responsible_name || a.responsible_tn}</b>
                            <span style={{ color: "#8A94A6" }}>
                              {a.due_date
                                ? `${String(a.due_date).slice(0, 10)} хүртэл`
                                : "хугацаа заагаагүй"}
                            </span>
                            <span
                              style={{
                                fontWeight: 800,
                                color:
                                  a.percent >= 100
                                    ? "#16A34A"
                                    : a.percent > 0
                                      ? "#CA8A04"
                                      : "#8A94A6",
                              }}
                            >
                              {a.percent || 0}%
                            </span>
                            {a.is_overdue ? (
                              <Tag color="red" style={{ fontSize: 10.5 }}>
                                хэтэрсэн
                              </Tag>
                            ) : null}
                          </div>
                        ))}
                      </div>
                    ) : null}

                    {it.fix_note ? (
                      <div
                        style={{
                          marginTop: 7,
                          padding: "7px 10px",
                          background: "#F6F8FB",
                          borderRadius: 6,
                          fontSize: 12,
                          color: "#3A4356",
                        }}
                      >
                        <b>Миний илгээсэн:</b> {it.fix_note}
                        {it.fix_photo_url ? (
                          <a
                            href={it.fix_photo_url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={it.fix_photo_url}
                              alt="Биелэлтийн зураг"
                              style={{
                                display: "block",
                                marginTop: 6,
                                maxWidth: 220,
                                maxHeight: 160,
                                borderRadius: 6,
                                objectFit: "cover",
                              }}
                            />
                          </a>
                        ) : null}
                      </div>
                    ) : null}

                    </div>{/* ma-left */}

                    {/* ══ БАРУУН: үйлдэл ══ */}
                    <div className="ma-right">
                      <div className="ma-right-st" style={{ "--c": st.color }}>
                        <span className="dot" />
                        {st.label}
                      </div>
                      {it.due_date ? (
                        <div
                          className="ma-right-due"
                          style={{ color: it.is_overdue ? "#DC2626" : "#5A6478" }}
                        >
                          <i className="far fa-calendar" />
                          {String(it.due_date).slice(0, 10)}
                          {it.is_overdue ? " · хэтэрсэн" : " хүртэл"}
                        </div>
                      ) : null}
                      {/* Гүйцэтгэлийн хувь — баруун талд байрлавал
                          товчнуудын хажууд, шийдвэр гаргахад хэрэгтэй */}
                      {it.fix_percent != null ? (
                        <div className="ma-right-pct">
                          <span className="bar">
                            <span
                              style={{
                                width: `${Math.min(100, it.fix_percent)}%`,
                                background:
                                  it.fix_percent >= 100
                                    ? "#16A34A"
                                    : it.fix_percent > 0
                                      ? "#CA8A04"
                                      : "#D6DBE3",
                              }}
                            />
                          </span>
                          <b>{it.fix_percent}%</b>
                        </div>
                      ) : null}
                      <div className="ma-act">
                      {/* ⚠ АЮУЛЫН МЭДЭЭЛЛИЙГ ЭНД ХААХГҮЙ. Түүнийг хаахад
                      хариу арга хэмжээ, дараах зураг шаардагдана —
                      /hazard/<id> дээр тэр маягт бий. Энд зөвхөн
                      «надад ирсэн» гэдгийг харуулна. */}
                      {it.readonly ? (
                        <Button
                          type="primary"
                          size="small"
                          style={{ background: BRAND, borderColor: BRAND }}
                          onClick={() =>
                            navigate(`/hazard/${it.hazard_report_id}`)
                          }
                        >
                          <i
                            className="fas fa-arrow-right"
                            style={{ marginRight: 5 }}
                          />
                          Шийдвэрлэх
                        </Button>
                      ) : it.kind !== "assignment" && it.fix_status !== "closed" ? (
                        /* ⚠ ХУВИАРЛАЛТЫН МӨРД (`asg-*`) ЭНЭ ТОВЧ ГАРАХГҮЙ.
                           Энэ товч `/xab/inspection-items/<int:id>/fix`
                           рүү `it.id`-г явуулдаг; хувиарлалтын мөрийн id
                           нь «asg-10» гэсэн НИЙЛМЭЛ утга тул `<int:>`
                           конвертерт таарахгүй → сервер 404 буцаана →
                           preflight унаж, браузер «CORS policy» гэж
                           ТӨӨРӨГДҮҮЛЭМ алдаа хэлнэ (2026-10-04).
                           Хувиарлалтын биелэлт нь доорх «Гүйцэтгэл
                           оруулах» товчоор, `item_result_id`-гаар явна. */
                        <Button
                          type="primary"
                          size="small"
                          style={{ background: BRAND, borderColor: BRAND }}
                          onClick={() => {
                            setFixOf(it);
                            setNote(it.fix_note || "");
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ marginRight: 5 }}
                          />
                          {it.fix_status === "submitted"
                            ? "Биелэлтээ засах"
                            : "Биелэлт оруулах"}
                        </Button>
                      ) : null}
                      {it.hazard_report_id && !it.readonly ? (
                        <Button
                          size="small"
                          onClick={() =>
                            navigate(`/hazard/${it.hazard_report_id}`)
                          }
                        >
                          Бүртгэлийг харах
                        </Button>
                      ) : null}

                      {/* ── ШАЛГАЛТТАЙ ТАНИЛЦАХ ────────────────────────
                          ⚠ Даалгавар нь «#12 гар багаж бүрэн бус» гэсэн
                          мөрөөр ирдэг ч ЯМАР шалгалтын, ямар нөхцөлд
                          илэрсэн нь хуудсан дээр л бий. Холбоосгүй бол
                          хариуцагч гүйцэтгэлээ таамгаар бичнэ. */}
                      {ins.id ? (
                        <Button
                          size="small"
                          icon={
                            <i
                              className="fas fa-clipboard-check"
                              style={{ marginRight: 5 }}
                            />
                          }
                          onClick={() => openInspection(ins.id)}
                        >
                          Шалгалтыг харах
                        </Button>
                      ) : null}

                      {/* ── УДИРДЛАГА АЖИЛТАНДАА ХУВИАРЛАХ ─────────────
                          Зөрчил хэсгийн дарга/мастерт ирээд тэр нь
                          чиглэлээрээ (цахилгаан · механик…) ажилтнууддаа
                          тарааж, гүйцэтгэлийг хянана. */}
                      {it.kind !== "hazard" && it.can_delegate ? (
                        <Button
                          size="small"
                          type={it.assignments?.length ? "default" : "dashed"}
                          icon={
                            <i
                              className="fas fa-users-cog"
                              style={{ marginRight: 5 }}
                            />
                          }
                          /* ⚠ ХААГДСАН зөрчлийг дахин хувиарлахгүй —
                             баталгаажсан биелэлт чимээгүй өөрчлөгдөхөөс
                             сэргийлнэ (2026-10-08). Харах нь нээлттэй. */
                          onClick={() =>
                            setAssignOf({
                              ...it,
                              _canAssign:
                                (it.fix_status || "open") !== "closed",
                            })
                          }
                        >
                          {(it.fix_status || "open") === "closed"
                            ? `Хувиарлалт харах${
                                it.assignments?.length
                                  ? ` (${it.assignments.length})`
                                  : ""
                              }`
                            : it.assignments?.length
                              ? `Хувиарлалт (${it.assignments.length})`
                              : "Ажилтанд хувиарлах"}
                        </Button>
                      ) : null}

                      {/* ── НАДАД ХУВИАРЛАГДСАН АЖИЛ — гүйцэтгэл оруулах
                          ⚠ Энэ мөр нь ЗӨРЧЛИЙН мөр БИШ, хувиарлалтын мөр
                          (`asg-*`) тул биелэлтийг өөр endpoint авдаг
                          (/inspection-assignments/<id>/progress). Тиймээс
                          дээрх «Биелэлт оруулах» биш, хувиарлалтын цонх. */}
                      {it.kind === "assignment" ? (
                        <Button
                          type="primary"
                          size="small"
                          style={{ background: BRAND, borderColor: BRAND }}
                          icon={
                            <i
                              className="fas fa-percent"
                              style={{ marginRight: 5 }}
                            />
                          }
                          onClick={() =>
                            setAssignOf({
                              ...it,
                              id: it.item_result_id,
                              _canAssign: false,
                            })
                          }
                        >
                          Гүйцэтгэл оруулах
                        </Button>
                      ) : null}
                      </div>
                    </div>{/* ma-right */}
                    </div>{/* ma-card */}
                  </Card>
                );
              })}
            </React.Fragment>
          ))}
        </div>
      )}

      <Modal
        open={!!fixOf}
        onCancel={() => {
          setFixOf(null);
          setPhotoUrl(null);
        }}
        onOk={send}
        okText="Илгээх"
        cancelText="Болих"
        confirmLoading={busy}
        okButtonProps={{ disabled: uploading }}
        title="Биелэлт оруулах"
      >
        <div style={{ fontSize: 12.5, color: "#5A6478", marginBottom: 8 }}>
          <b>Даалгавар:</b> {fixOf?.finding_text || fixOf?.item_text}
        </div>
        <Input.TextArea
          rows={4}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Юуг хэрхэн засаж арилгасныг тодорхой бичнэ үү"
        />

        {/* Арилгасны дараах ЗУРАГ — шалгагч баталгаажуулахдаа харна */}
        <div style={{ marginTop: 10 }}>
          <Upload
            accept="image/*"
            showUploadList={false}
            beforeUpload={onPickPhoto}
            disabled={uploading}
          >
            <Button
              size="small"
              loading={uploading}
              icon={<i className="fas fa-camera" style={{ marginRight: 6 }} />}
            >
              {photoUrl ? "Зураг солих" : "Зураг хавсаргах"}
            </Button>
          </Upload>
          {photoUrl ? (
            <div
              style={{
                marginTop: 8,
                position: "relative",
                display: "inline-block",
              }}
            >
              <img
                src={photoUrl}
                alt="Биелэлтийн зураг"
                style={{
                  maxWidth: 260,
                  maxHeight: 180,
                  borderRadius: 8,
                  display: "block",
                }}
              />
              <Button
                size="small"
                danger
                style={{ position: "absolute", top: 4, right: 4 }}
                onClick={() => setPhotoUrl(null)}
              >
                ✕
              </Button>
            </div>
          ) : (
            <div style={{ fontSize: 11, color: "#A8AFBC", marginTop: 4 }}>
              Арилгасны дараах байдлын зураг — заавал биш, гэхдээ
              баталгаажуулахад тустай.
            </div>
          )}
        </div>
        <div style={{ fontSize: 11, color: "#A8AFBC", marginTop: 6 }}>
          Илгээсний дараа шалгагч хүлээн авч хаана. Буцаагдвал шалтгаан нь энд
          харагдана.
        </div>
      </Modal>

      {/* ⚠ ХУВИАРЛАХ / ГҮЙЦЭТГЭЛ — нэг цонх хоёр үүрэг:
          `_canAssign` бол удирдлага ажилтнуудаа тохируулна, эс бөгөөс
          хувиарлагдсан ажилтан ӨӨРИЙН мөрөндөө хувь, тайлбар, зураг
          оруулна (эрхийг backend мөн шалгана). */}
      {assignOf ? (
        <AssignmentEditor
          open
          item={assignOf}
          canAssign={!!assignOf._canAssign}
          onClose={() => setAssignOf(null)}
          onSaved={() => {
            setAssignOf(null);
            load();
          }}
        />
      ) : null}
    </div>
  );
}
